import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { CustomTableReport } from 'src/app/interfaces/custom-table-report/custom-table-report.interface';
import { InvoicingReportFilterModel } from 'src/app/models/invoicing/invoicing-report-filter.model';
import { ArticleService } from 'src/app/services/archive/article.service';
import { CostCenterService } from 'src/app/services/archive/cost-center.service';
import { GroupService } from 'src/app/services/archive/group.service';
import { StoreService } from 'src/app/services/archive/store.service';
import { SubgroupService } from 'src/app/services/archive/subgroup.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { InventoryClassService } from 'src/app/services/inventory/inventory-class.service';
import { InvoicingReportService } from 'src/app/services/invoicing/invoicing-report.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { EnterpriseService } from 'src/app/services/management/enterprise.service';
import { RentalPeriodService } from 'src/app/services/rental/rental-period.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { CustomValidators } from 'src/app/validators/custom-validators';

@Component({
  selector: 'app-item-revenue-store',
  templateUrl: './item-revenue-store.component.html',
  styleUrls: ['./item-revenue-store.component.scss'],
  standalone: false
})
export class ItemRevenueStoreComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('filtersContainer') filtersContainer!: ElementRef;

  captionFilters: string[] = [];
  changeFilters: boolean = false;
  dataReport: CustomTableReport;
  filterObserver?: ResizeObserver;
  filtersHeight: number = 0;
  filteredEnterprise: any[] = [];
  filteredStores: any[] = [];
  filteredSubgroups: any[] = [];
  formInvoicingReportFilter: FormGroup = new FormGroup({});
  groupId: number | null = null;
  inventoryId: number = 0;
  listArticle: any[] = [];
  listBranch: any[] = [];
  listCostCenter: any[] = [];
  listCostCenterTypes: CustomListDropdown[] = [{ label: 'Todos', value: 0 }, { label: 'Tercero', value: 1 },
  { label: 'Administración', value: 2 }, { label: 'Propio', value: 3 }];
  listClassInventory: any[] = [];
  listEnterprise: any[] = [];
  listGroup: any[] = [];
  listLevels: CustomListDropdown[] = [{ label: 'Independientes', value: 0 }, { label: 'Dependientes', value: 1 }];
  listStore: any[] = [];
  listSubgroup: any[] = [];
  nameWindow: string = 'Informe de Ingresos por Equipo Bodega';
  projectName = ProjectName.projectName;
  storeId: number = 0;

  constructor(private articleService: ArticleService,
    private branchService: BranchService,
    private costCenterService: CostCenterService,
    private enterpriseService: EnterpriseService,
    private formBuilder: FormBuilder,
    private groupService: GroupService,
    private headerService: HeaderService,
    private inventoryClassService: InventoryClassService,
    private invoicingReportService: InvoicingReportService,
    private rentalPeriodService: RentalPeriodService,
    private storeService: StoreService,
    private subgroupService: SubgroupService,
    private title: Title,
    private toastHandlerService: ToastHandlerService) {
    this.validateForm();
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getAllLists();
    this.getFirstBranchByUserAuthenticatedAsync();
  }

  ngAfterViewInit() {
    this.filterObserver = new ResizeObserver(() => {
      this.filtersHeight = this.filtersContainer?.nativeElement?.offsetHeight || 0;
    });
    this.filterObserver.observe(this.filtersContainer.nativeElement);
  }

  ngOnDestroy() {
    this.filterObserver?.disconnect();
  }

  changeArticle(articleId: number | null) {
    if (articleId != 0 && articleId != null) {
      this.formInvoicingReportFilter.controls["articleId"].patchValue(articleId);
    } else {
      this.formInvoicingReportFilter.controls["articleId"].patchValue(0);
    }
    this.changeFilters = false;
  }

  async changeBranch(branchId: number | null) {
    this.filterEnterpriseByBranchId(branchId);
    if (branchId != 0 && branchId != null) {
      this.getFirstEnterpriseByBranch(branchId);
    } else {
      this.formInvoicingReportFilter.controls["branchId"].patchValue(0);
      this.formInvoicingReportFilter.controls["enterpriseId"].patchValue(0);
    }
    this.changeFilters = false;
  }

  changeClassInventory(inventoryClassId: number | null) {
    this.filterStoreByInventoryClassId(inventoryClassId);
    if (inventoryClassId != 0 && inventoryClassId != null) {
      this.formInvoicingReportFilter.controls["storeId"].patchValue(0);
    } else {
      this.formInvoicingReportFilter.controls["inventoryClassId"].patchValue(0);
      this.formInvoicingReportFilter.controls["storeId"].patchValue(0);
    }
    this.changeFilters = false;
  }

  changeCostCenter(costCenter: number | null) {
    if (costCenter == null || costCenter == 0) {
      this.formInvoicingReportFilter.controls["costCenterId"].patchValue(0);
    }
    this.changeFilters = false;
  }

  changeEnterprise(enterpriseId: number | null) {
    if (enterpriseId == 0 || enterpriseId == null) {
      this.formInvoicingReportFilter.controls["enterpriseId"].patchValue(0);
    }
    this.changeFilters = false;
  }

  changeFilter() {
    this.changeFilters = false;
  }

  changeGroup(groupId: number | null) {
    this.filterSubgroupByGroupId(groupId);
    if (groupId != 0 && groupId != null) {
      this.formInvoicingReportFilter.controls["subgroupId"].patchValue(0);
      this.groupId = groupId;
    } else {
      this.formInvoicingReportFilter.controls["groupId"].patchValue(0);
      this.formInvoicingReportFilter.controls["subgroupId"].patchValue(0);
      this.groupId = null;
    }
    this.changeFilters = false;
  }

  changeStore(storeId: number | null) {
    if (storeId != 0 && storeId != null) {
      this.storeId = storeId;
      const inventoryClassId = this.listStore.find(x => x.value == storeId)!.inventoryClassId;
      this.formInvoicingReportFilter.controls["inventoryClassId"].patchValue(inventoryClassId);
    } else {
      this.formInvoicingReportFilter.controls["storeId"].patchValue(0);
      this.storeId = 0;
    }
    this.changeFilters = false;
  }

  changeSubgroup(subgroupId: number | null) {
    if (subgroupId != 0 && subgroupId != null) {
      const groupId = this.listSubgroup.find(x => x.value == subgroupId)!.groupId;
      this.formInvoicingReportFilter.controls["groupId"].patchValue(groupId);
    } else {
      this.formInvoicingReportFilter.controls["groupId"].patchValue(0);
      this.formInvoicingReportFilter.controls["subgroupId"].patchValue(0);
    }
    this.changeFilters = false;
  }

  clear() {
    this.changeFilters = false;
    this.validateForm();
    this.getFirstBranchByUserAuthenticatedAsync();
    this.filterStoreByInventoryClassId(null);
    this.filterSubgroupByGroupId(null);
    this.filterEnterpriseByBranchId(null);
  }

  async exportExcel() {
    if (this.changeFilters) {
      const dateInitial = this.formInvoicingReportFilter.controls['initialDate'].value;
      const dateFinal = this.formInvoicingReportFilter.controls['finalDate'].value;
      const initialDate = `${dateInitial.getFullYear()}-${(dateInitial.getMonth() + 1).toString().padStart(2, '0')}`;
      const finalDate = `${dateFinal.getFullYear()}-${(dateFinal.getMonth() + 1).toString().padStart(2, '0')}`;
      const period = initialDate.slice(5);
      const year = initialDate.slice(0, -3);
      const periodFinal = finalDate.slice(5);
      const yearFinal = finalDate.slice(0, -3);
      try {
        const modelInvoicingReportFilter = this.formInvoicingReportFilter.value as InvoicingReportFilterModel;
        modelInvoicingReportFilter.year = parseInt(year);
        modelInvoicingReportFilter.period = parseInt(period);
        modelInvoicingReportFilter.yearFinal = parseInt(yearFinal);
        modelInvoicingReportFilter.periodFinal = parseInt(periodFinal);
        const response = await firstValueFrom(this.invoicingReportService.exportInvoicingReportItemRevenueStore(modelInvoicingReportFilter));
        const blob = response;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Informe de Ingresos por Equipo Bodega.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error al exportar el informe.', error);
      }
    } else {
      this.toastHandlerService.showToast(
        'info',
        'No se encontraron datos para exportar.'
      );
    }
  }

  filterEnterpriseByBranchId(branchId: number | null) {
    if (branchId != null) {
      this.filteredEnterprise = this.listEnterprise.filter(x => x.branchId === branchId);
      this.formInvoicingReportFilter.controls["enterpriseId"].patchValue(0);
    } else {
      this.filteredEnterprise = this.listEnterprise;
    }
  }

  filterStoreByInventoryClassId(inventoryClassId: number | null) {
    const rowsFiltered = this.listStore.filter(x => x.inventoryClassId === inventoryClassId);
    if (inventoryClassId != null) {
      this.filteredStores = rowsFiltered;
      const storeId = this.formInvoicingReportFilter.get("storeId")?.value;
      const store = this.listSubgroup.find(x => x.inventoryClassId == inventoryClassId);
      if ((storeId && store) && store.value != storeId) {
        this.formInvoicingReportFilter.controls["storeId"].patchValue(0);
      }
    } else {
      this.filteredStores = this.listStore;
    }
  }

  filterSubgroupByGroupId(groupId: number | null) {
    const rowsFiltered = this.listSubgroup.filter(x => x.groupId === groupId);
    if (groupId != null) {
      this.filteredSubgroups = rowsFiltered;
      const subgroupId = this.formInvoicingReportFilter.get("subgroupId")?.value;
      const subgroup = this.listSubgroup.find(x => x.groupId == groupId);
      if ((subgroupId && subgroup) && subgroup.value != subgroupId) {
        this.formInvoicingReportFilter.controls["subgroupId"].patchValue(0);
      }
    } else {
      this.filteredSubgroups = this.listSubgroup;
    }
  }

  async getAllLists() {
    try {
      const [branches, enterprises, costCenters, groups, subgroups, articles, classInventories, stores] = await Promise.all([
        firstValueFrom(this.branchService.getAllBranchesForSelectAsync()),
        firstValueFrom(this.enterpriseService.getAllEnterprisesForSelectAsync()),
        firstValueFrom(this.costCenterService.getAllCostCentersForSelectAsync()),
        firstValueFrom(this.groupService.getAllGroupsForSelectAsync()),
        firstValueFrom(this.subgroupService.getAllSubgroupsForSelectAsync()),
        firstValueFrom(this.articleService.getAllArticlesForSelectAsync()),
        firstValueFrom(this.inventoryClassService.getAllInventoryClassForSelectAsync()),
        firstValueFrom(this.storeService.getAllStoresForSelectAsync())
      ]);
      this.listBranch = branches;
      this.listEnterprise = enterprises;
      this.filteredEnterprise = this.listEnterprise;
      this.listCostCenter = costCenters;
      this.listGroup = groups;
      this.listSubgroup = subgroups;
      this.filteredSubgroups = this.listSubgroup;
      this.listArticle = articles;
      this.listClassInventory = classInventories;
      this.listStore = stores;
      this.filteredStores = this.listStore;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas:', error);
      return false;
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    try {
      const branch = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      this.formInvoicingReportFilter.controls["branchId"].patchValue(branch.branchId);
      this.getLastRentalPeriod(branch.branchId);
      this.filterEnterpriseByBranchId(branch.branchId);
      this.getFirstEnterpriseByBranch(branch.branchId);
    } catch (error) {
      console.error("Error al consultar la sucursal:", error);
    }
  }

  async getFirstEnterpriseByBranch(branchId: number) {
    try {
      const response = await firstValueFrom(this.enterpriseService.getFirstEnterpriseByBranch(branchId));
      if (!response) {
        this.toastHandlerService.showToast('error', 'La Sucursal no tiene empresas creadas.');
      } else {
        this.formInvoicingReportFilter.controls["enterpriseId"].patchValue(response.enterpriseId);
      }
    } catch (error) {
      console.error('Error al obtener la primera empresa por sucursal.', error);
    }
  }

  async getLastRentalPeriod(branchId: number) {
    try {
      const rentalPeriod = await firstValueFrom(this.rentalPeriodService.getLastRentalPeriod(branchId));
      this.formInvoicingReportFilter.controls["initialDate"].patchValue(moment(rentalPeriod.initialDate).startOf('month').toDate());
      this.formInvoicingReportFilter.controls["finalDate"].patchValue(moment(rentalPeriod.finalDate).startOf('month').toDate());
    } catch (error) {
      console.error("Error al consulta el periodo de alquiler:", error);
    }
  }

  printReport() {
    if (this.changeFilters) {
      window.print();
    } else {
      this.toastHandlerService.showToast(
        'info',
        'No se encontraron datos para imprimir.'
      );
    }
  }

  async send() {
    Object.keys(this.formInvoicingReportFilter.controls).forEach(key => {
      const control = this.formInvoicingReportFilter.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });
    if (this.formInvoicingReportFilter.valid) {
      const dateInitial = this.formInvoicingReportFilter.get("initialDate")?.value;
      const initialDate = `${dateInitial.getFullYear()}-${(dateInitial.getMonth() + 1).toString().padStart(2, '0')}`;
      const period = initialDate.slice(5);
      const year = initialDate.slice(0, -3);
      const dateFinal = this.formInvoicingReportFilter.get("finalDate")?.value;
      const finalDate = `${dateFinal.getFullYear()}-${(dateFinal.getMonth() + 1).toString().padStart(2, '0')}`;
      const periodFinal = finalDate.slice(5);
      const yearFinal = finalDate.slice(0, -3);

      if (finalDate < initialDate) {
        this.toastHandlerService.showToast('warning', 'El período final no puede ser menor al período inicial.');
        return;
      }

      const modelInvoicingReportFilter = this.formInvoicingReportFilter.value as InvoicingReportFilterModel;
      modelInvoicingReportFilter.year = parseInt(year);
      modelInvoicingReportFilter.period = parseInt(period);
      modelInvoicingReportFilter.yearFinal = parseInt(yearFinal);
      modelInvoicingReportFilter.periodFinal = parseInt(periodFinal);

      try {
        this.dataReport = await firstValueFrom(this.invoicingReportService.getItemRevenueStore(modelInvoicingReportFilter));
        if (this.dataReport.data && this.dataReport.data.length != 0 && this.dataReport.data.length != null) {
          this.changeFilters = true;
        } else {
          this.changeFilters = false;
          this.toastHandlerService.showToast('info', 'No se encontraron datos.');
        }
      } catch (error) {
        console.error("Error al consultar el informe:", error);
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      initialDate: {
        required: 'El campo Desde es obligatorio.'
      },
      finalDate: {
        required: 'El campo Hasta es obligatorio.'
      },
      costCenterId: {
        notNumber: 'Debe seleccionar un C.Costos válido.'
      },
      groupId: {
        notNumber: 'Debe seleccionar un Grupo válido.'
      },
      subgroupId: {
        notNumber: 'Debe seleccionar un Subgrupo válido.'
      },
      articleId: {
        notNumber: 'Debe seleccionar un Artículo válido.'
      },
      inventoryClassId: {
        notNumber: 'Debe seleccionar una Clase de Inventario válida.'
      },
      storeId: {
        notNumber: 'Debe seleccionar una Bodega válida.'
      }
    };

    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formInvoicingReportFilter.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  validateForm() {
    this.formInvoicingReportFilter = this.formBuilder.group({
      initialDate: ['', [Validators.required]],
      finalDate: ['', [Validators.required]],
      branchId: [0],
      enterpriseId: [0],
      costCenterId: [0, [CustomValidators.numberOnlyValidator()]],
      costCenterTypeId: [0],
      groupId: [0, [CustomValidators.numberOnlyValidator()]],
      subgroupId: [0, [CustomValidators.numberOnlyValidator()]],
      articleId: [0, [CustomValidators.numberOnlyValidator()]],
      inventoryClassId: [0, [CustomValidators.numberOnlyValidator()]],
      storeId: [0, [CustomValidators.numberOnlyValidator()]],
      levelArticle: [0]
    });
  }

}
